import { render, staticRenderFns } from "./CustomRatingManageRiskAssessmentModal.vue?vue&type=template&id=087ba278&"
import script from "./CustomRatingManageRiskAssessmentModal.vue?vue&type=script&lang=js&"
export * from "./CustomRatingManageRiskAssessmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports